import React from 'react';

import { TableColumn } from '@hero/ui-kit/tables/Table';
import Button from '@hero/ui-kit/inputs/Button';

export type ActionHandler = (folder: string) => void;

export type LogsTableItem = { files: string; folder: string };

type Render = TableColumn<LogsTableItem>['render'];

type GetActionRender = (actionHandler: ActionHandler) => Render;

const selectRender: GetActionRender =
    (actionHandler) =>
    ({ folder }) => {
        const handleClick = React.useCallback(() => {
            actionHandler(folder);
        }, [folder]);

        return (
            <Button size="small" onClick={handleClick}>
                Select
            </Button>
        );
    };

type GetTableColumns = (selectHandler: ActionHandler) => TableColumn<LogsTableItem>[];
const getTableColumns: GetTableColumns = (selectHandler) => [
    {
        colKey: 'files',
        name: 'Select Folder',
        align: 'left',
        headAlign: 'left',
        render: selectRender(selectHandler)
    },
    {
        colKey: 'folder',
        name: 'Folder'
    }
];

export default getTableColumns;
